<template>
  <div class="content-container">
    <search-comp
      @onSearch="attachData"
      @onReset="
        () => {
          searchParams.isActive = 2
          attachData()
        }
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>

                <el-select
                  v-model="searchParams.isActive"
                  placeholder="Vui lòng chọn"
                  @change="attachData"
                >
                  <el-option label="Tất cả" :value="2"> </el-option>
                  <el-option label="Đang hoạt động" :value="1"> </el-option>
                  <el-option label="Không hoạt động" :value="0"> </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :row-multi-select-with-click="true"
        @selectionChanged="selectionChanged"
      />
    </div>

    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteMarketSegment"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        !isEdit ? 'Thêm phân khúc thị trường' : 'Sửa phân khúc thị trường'
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã phân khúc thị trường</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã phân khúc thị trường"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider
                    rules="required|max:255"
                    name="Mô tả phân khúc thị trường"
                  >
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Nhóm phân khúc thị trường</div>
                  <validation-provider
                    rules="required|max:255"
                    name="Nhóm phân khúc thị trường"
                  >
                    <select-with-search-table
                      style="width: 100%"
                      :rows="marketSegmentGroupOptions"
                      :columns="columnsGroup"
                      :value="form.p_id"
                      :selected-index-field-value="form.p_id"
                      index-field="id"
                      @selectionChanged="onSelectRowOption"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.code }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label" style="margin-right: 10px">Hoạt động</div>
                  <el-switch
                    v-model="form.active"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateMarketSegment"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addMarketSegment">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders.js'
import { getMarketSegmentGroupApi } from '@/api/Statistics/marketSegmentGroup'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'

import {
  getMarketSegmentApi,
  addMarketSegmentApi,
  updateMarketSegmentApi,
  deleteMarketSegmentApi
} from '@/api/Statistics/marketSegment'
import { Message } from 'element-ui'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderToggleSwitchReadOnly,
    SelectWithSearchTable
  },
  data() {
    return {
      isDisableModify: false,
      isDisableDelete: false,
      loading: false,
      defaultForm: {
        code: '',
        desc: '',
        id: null,
        order: 0,
        active: true,
        p_id: null
      },
      form: {
        code: '',
        desc: '',
        id: null,
        order: 0,
        active: true,
        p_id: null
      },

      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        isActive: 2
      },

      marketSegmentGroupOptions: [],
      columnsGroup: [
        {
          headerName: 'Mã nhóm',
          field: 'code',
          minWidth: 150,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          sortable: false,
          flex: 1
          // cellRenderer: 'CellRenderTextInput',
        }
      ],

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã phân khúc',
          field: 'code',
          width: 100,
          sortable: false
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          sortable: false
          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Nhóm phân khúc',
          field: 'p_code',
          sortable: false
          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Hoạt động',
          field: 'active',
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          sortable: false,
          cellRendererParams: params => {
            return {
              active: params.data.active
            }
          }
        }
      ],

      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  },
  beforeMount() {
    this.getMarketSegmentGroup()
  },

  mounted() {
    this.attachData()
  },
  methods: {
    onSelectRowOption(val) {
      this.form.p_id = val.id
    },
    onChangeActive() {
      if (this.isActive) {
        this.attachData({ isActive: 0 })
      } else {
        this.attachData({ isActive: 1 })
      }
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async getMarketSegmentGroup() {
      let data = await getMarketSegmentGroupApi({ isActive: 1 })
      this.marketSegmentGroupOptions = data.data
    },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      let data = await getMarketSegmentApi(this.searchParams)
      // bus.$emit('endLoader')
      this.loading = false
      this.rows = data.data
    },
    async addMarketSegment() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addMarketSegmentApi(this.form)
        .then(async res => {
          const message = res.message
          // if (this.isActive) {
          //   this.attachData({ isActive: 0 })
          // } else {
          //   this.attachData({ isActive: 1 })
          // }
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateMarketSegment() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateMarketSegmentApi(this.form)
        .then(async res => {
          const message = res.message
          // if (this.isActive) {
          //   this.attachData({ isActive: 0 })
          // } else {
          //   this.attachData({ isActive: 1 })
          // }
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteMarketSegment() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteMarketSegmentConfirm'), () => {
          deleteMarketSegmentApi({
            ids: id_list
          })
            .then(async res => {
              const message = res.message
              // if (this.isActive) {
              //   this.attachData({ isActive: 0 })
              // } else {
              //   this.attachData({ isActive: 1 })
              // }
              this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },

    updateView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form.order = rowData.order
        this.form.id = rowData.id
        this.form.p_id = rowData.p_id
        this.form.code = rowData.code
        this.form.desc = rowData.desc
        this.form.active = rowData.active
        this.dialogFormVisible = true
      }
    },
    resetItemInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
